<div class="card-header d-lg-none align-items-center px-5 px-lg-9 py-5 gap-5">
  <app-breadcrumb-custom type="bc" [title]="data.name"></app-breadcrumb-custom>
</div>

<div class="card-body">
  <section #intro>
    <div class="d-flex flex-wrap gap-2 justify-content-between align-items-center mb-4">
      <div class="d-flex align-items-center flex-wrap gap-2">
        <h2 class="d-none d-lg-block fw-bold me-3 my-1">{{ data.name }}</h2>

        <!-- A category, not an error. `badge-light-danger` painted it red on
             pink here while the lesson page painted the same string blue. -->
        <span class="badge badge-light-primary my-1 me-2">{{
          data.course_category_name
          }}</span>
        <!-- <span class="badge badge-light-danger my-1">important</span> -->
      </div>
    </div>
    <div class="mb-4">
      <app-rating-star [rating]="data.rating || 0"></app-rating-star>
    </div>

    <div class="collapse fade show">
      <div class="py-5 fs-3">
        <p class="mb-0">
          {{ data.description }}
        </p>
        <!-- <p>Best regards,</p>
          <p class="mb-0">Jason Muller</p> -->
      </div>
    </div>

    <div>
      <section class="mt-12">
        <p class="mb-2 fs-4">{{ "APP.TEACH_BY" | translate }}</p>
        <div class="d-flex flex-wrap gap-2 flex-stack cursor-pointer">
          <div class="d-flex align-items-center">
            @if(data.tutor){
            <div class="symbol symbol-circle symbol-30px me-4">
              @if (data.tutor?.image_url) {
              <img [src]="`${fileUrl}${data.tutor.image_url}`" [attr.alt]="data.tutor.name" class="object-fit-cover" />
              } @else {
              <span class="symbol-label bg-light-primary text-primary">
                <app-keenicon name="user" class="fs-3 text-primary"></app-keenicon>
              </span>
              }
            </div>

            }
            <a class="text-gray-800 fw-bold fs-4 me-2">
              {{ data.tutor?.name || "-" }}
            </a>
          </div>
        </div>
      </section>
    </div>
  </section>
  <div class="col-12">
    <ng-content select="[orderCard]"></ng-content>
  </div>
  <div class="col-12">
    <ng-content select="[courseOptions]"></ng-content>
  </div>
  <div class="separator my-6"></div>

  <section #courseDesp>
    <p class="fs-2 fw-semibold mt-12">{{ "APP.DESCRIPTION" | translate }}</p>
    <div class="fs-4 fw-normal" [innerHTML]="data.explain"></div>
  </section>

  <!-- Heading and list stand or fall together: the heading used to be outside
       the guard, so a course with no outcomes printed "คุณจะได้เรียนอะไรบ้าง"
       over nothing and ran straight into the chapter list. -->
  @if (data?.course_lessons?.length) {
  <section>
    <p class="fs-2 fw-semibold mt-16">
      {{ "APP.COURSE_BENEFITS" | translate }}
    </p>
    <div class="d-flex flex-column gap-4 mb-12">
      @for (lesson of data.course_lessons; track $index) {
      <div class="d-flex flex-row align-items-center gap-2">
        <app-keenicon name="check-circle" class="fs-1 text-primary"></app-keenicon>
        <span class="fs-5">{{ lesson.lesson_name }}</span>
      </div>
      }
    </div>
  </section>
  }

  <!--begin::Chapter accordion-->
  <section>
    <p class="fs-4 fw-normal mt-1">{{ "APP.COURSE_DESC" | translate }}</p>

    <div data-kt-inbox-message="message_wrapper">
      <div class="card mb-1">
        @if(!data?.course_preview?.youtube_url &&
        data?.course_preview?.image_url){
        <div class="text-center p-8">
          <img class="ratio-16x9 object-fit-cover rounded" [src]="fileUrl + data?.course_preview?.image_url"
            [attr.alt]="data.name" />
        </div>

        } @if(data?.course_preview?.youtube_url ||
        data?.course_preview?.youtube_url && data?.course_preview?.image_url ){
        <div class="video p-8 ratio-16x9">
          <iframe [src]="getTrustedVideoURL(data?.course_preview?.youtube_url)" width="100%" height="100%"
            frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen class="rounded">
          </iframe>
        </div>

        } @if(data.course_chapter_groups.length){
        <div class="accordion" id="kt_course_accordion">
          @for (item of data.course_chapter_groups; track $index ; let i =
          $index) {
          <!-- Same list as the classroom playlist — `.lesson-group` /
               `.lesson-row` live in the skin, so a course's curriculum and the
               playlist a student sees after buying it are the same object. -->
          <div role="button" data-bs-toggle="collapse" [attr.data-bs-target]="`#kt_course_lesson_${i+1}`"
            [attr.aria-controls]="`kt_course_lesson_${i+1}`" aria-expanded="false" class="lesson-group collapsed">
            <span class="lesson-group__chevron">
              <app-keenicon name="down" class="fs-3 rotate"></app-keenicon>
            </span>
            <span class="lesson-group__id">
              <span class="lesson-group__name">{{ item.name }}</span>
              <span class="lesson-group__meta">
                <app-keenicon name="youtube" class="fs-5"></app-keenicon>
                {{ item.course_chapters.length }} {{ "APP.VIDEOS" | translate }}
              </span>
            </span>
            <span class="lesson-group__time">
              {{ item.duration_video | durationVideo : "HH:mm:ss" }}
            </span>
          </div>

          <div class="collapse fade" [id]="`kt_course_lesson_${i+1}`" data-bs-parent="#kt_course_accordion">
            <div class="lesson-rows border-top">
              @for (sub_item of item.course_chapters; track $index) {
              <div class="lesson-row">
                <span class="lesson-row__cue">
                  <app-keenicon name="lock-2" class="fs-4"></app-keenicon>
                </span>
                <span class="lesson-row__name">{{ sub_item.chapter.name }}</span>
                <!-- Chapters flagged is_preview are the ones a trial unlocks,
                     but only inside the classroom after enrolling — the public
                     page offers no way to play them. -->
                @if (sub_item.is_preview && sub_item.chapter?.has_hls) {
                <span class="badge badge-light-success flex-shrink-0">
                  {{ "APP.FREE_TRIAL" | translate }}
                </span>
                }
                <span class="lesson-row__time">
                  {{ sub_item.chapter.duration_video | durationVideo : "HH:mm:ss" }}
                </span>
              </div>
              }
            </div>
          </div>
          }
        </div>
        } @else {
        <div class="card">
          <div class="card-header border-0 align-items-center collapsed py-6 fs-5 fw-light text-muted">
            {{ "APP.NO_LESSON" | translate }}
          </div>
        </div>
        }
      </div>
    </div>
  </section>
</div>